import React from 'react';

const BottomFooter = () => {
  return (
    <footer 
      className='bottom-footer bg-color-three' 
      style={{
        backgroundColor: '#43b9dc',
        width: '100%',
        marginTop: 'auto'
      }}
    >
      <div 
        className='container container-lg' 
        style={{
          backgroundColor: '#43b9dc'
        }}
      >
        <p 
          className='bottom-footer__text center py-20' 
          style={{
            color: 'white',
            margin: 0,
            textAlign: 'center'
          }}
        >
          © Copyright Rarenett Technologies 2025. All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default BottomFooter;
